export const SITE_LOGO = "/logo.png";

// To update the logo, change the URL above or use a local path like "/logo.png"
